import { useState } from 'react';
import { IconPencil, IconTrash } from '@tabler/icons-react';
import { useToast } from '@hana/ui';
import { useT } from '@hana/i18n';
import './roePhone.i18n';
import { norm } from './view';
import { ROE_LABELS, ROE_ROWS, roePaths } from './roe';
import s from './supplierPay.module.css';

// Mint-SupplierPay › tab Tỷ giá: biểu đồ USD bán 6 tháng + bảng theo ngày (sửa / xoá). Chỉ đọc; ghi báo toast.
const W = 1240 - 36;
export function RoeTab({ q }: { q: string }) {
  const toast = useToast();
  const tx = useT();
  const [gone, setGone] = useState<ReadonlySet<string>>(new Set());
  const { path, grid } = roePaths(W);
  const rows = ROE_ROWS.filter((r) => !gone.has(r.code) && (!q || norm(`${r.d} ${r.code}`).includes(norm(q))));
  const n0 = (x: number) => x.toLocaleString('vi-VN');
  return (
    <>
      <section className={`${s.card} ${s.roeChart}`} aria-label={tx('fnr.chart')}>
        <div className={s.ch}><h2>{tx('fnr.title')}</h2><span className={s.leg}>23/Apr – 22/Oct/2026</span></div>
        <svg role="img" aria-label={tx('fnr.chartImg')} width={W} height={160} viewBox={`0 0 ${W} 160`}>
          <path d={grid} className={s.roeGrid} fill="none" />
          <path d={path} className={s.roeLine} fill="none" />
        </svg>
        <div className={s.roeLbl}>{ROE_LABELS.map((l) => <span key={l}>{l}</span>)}</div>
      </section>
      <section className={`${s.card} ${s.roeTable}`} aria-label={tx('fnr.byDay')}>
        <div className={`${s.roeRow} ${s.roeHead}`}>
          <span>{tx('fnr.date')}</span><span>{tx('fnr.usdBuy')}</span><span>{tx('fnr.usdSell')}</span><span>{tx('fnr.eurBuy')}</span><span>{tx('fnr.eurSell')}</span><span className={s.roeSrc}>{tx('fnr.src')}</span><span>{tx('fnr.who')}</span><span />
        </div>
        {rows.map((r) => (
          <div key={r.code} className={s.roeRow}>
            <span><b>{r.d}</b><div className={s.roeCode}>{r.code}</div></span>
            <span>{n0(r.usdBuy)}</span><b>{n0(r.usdSell)}</b><span>{n0(r.eurBuy)}</span><span>{n0(r.eurSell)}</span>
            <span className={`${s.roeSrc} ${s.tx2}`}>{r.src}</span><span className={s.tx2}>{r.who}</span>
            <span className={s.roeAct}>
              <button type="button" aria-label={tx('fnr.editAria', { d: r.d })} onClick={() => toast({ msg: tx('fnp.noWrite') })}><IconPencil size={16} aria-hidden="true" />{tx('fnr.edit')}</button>
              <button type="button" aria-label={tx('fnr.delAria', { d: r.d })} onClick={() => { setGone(new Set([...gone, r.code])); toast({ msg: tx('fnr.deleted', { d: r.d }) }); }}><IconTrash size={16} aria-hidden="true" /></button>
            </span>
          </div>
        ))}
        <div className={s.roeFoot}>{tx('fnr.unit')}</div>
      </section>
    </>
  );
}
